import { memo } from 'react';
import { useTheme } from '@mui/material';
import SuccessIllustrationLight from './success.svg?react';
import SuccessIllustrationDark from './success_dark.svg?react';

export const SuccessIllustration = memo(
  (props: React.SVGProps<SVGSVGElement>) => {
    const theme = useTheme();

    if (theme.palette.type === 'dark')
      return <SuccessIllustrationDark aria-hidden="true" {...props} />;
    return <SuccessIllustrationLight aria-hidden="true" {...props} />;
  },
);
